/*
 * SPDX-FileCopyrightText: 2018 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

export default Object.freeze({
	STATE_DISABLED: 0,
	STATE_CREATED: 1,
	STATE_ENABLED: 2,
})
